import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { logger } from '../../datadog';
import { UserType } from '../../types';
import { DataChannelMessageType, DataChannelSessionIntentionEditedMessage, useSendMessage } from '../../video-sdk';

export function useSendSessionIntentionEditedCallback() {
  const { patientShortId } = useParams();
  const sendMessage = useSendMessage();

  return useCallback(
    async (shortId: string) => {
      logger.info('Sent data channel message', {
        messageType: DataChannelMessageType.SESSION_INTENTION_EDITED,
        sender: 'client',
      });

      const message: DataChannelSessionIntentionEditedMessage = {
        type: DataChannelMessageType.SESSION_INTENTION_EDITED,
        sender: {
          entityId: patientShortId ?? '',
          entityType: UserType.CLIENT,
        },
        sessionIntention: {
          shortId,
          editedAt: new Date().toISOString(),
        },
      };

      await sendMessage(message);
    },
    [sendMessage, patientShortId],
  );
}
